var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextsummarize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.104,
    height: 57.055,
    viewBox: "0 0 57.104 57.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.035,
    height: 1.904,
    transform: "translate(11.518 10.566)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.746,
    height: 1.904,
    transform: "translate(5.807 21.987)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.746,
    height: 1.904,
    transform: "translate(5.807 42.926)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.579,3.063h0a3.642,3.642,0,0,0-5.144,0L49.387,5.111,34.36,20.139V4.855a.952.952,0,0,0-.952-.952H2.952A.952.952,0,0,0,2,4.855V52.443a.952.952,0,0,0,.952.952H32.532a6.662,6.662,0,0,0,13.249-.952V37.215a.952.952,0,0,0-.952-.952H34.36V31.141L38.648,29c.031-.016.049-.048.079-.068a.891.891,0,0,0,.168-.111L56,11.718l2.047-2.047a3.642,3.642,0,0,0,0-5.14ZM50.064,7.13l1.285,1.285L35.59,24.169l-.831-.831-.454-.454ZM32.456,37.215V51.492H3.9V5.807H32.456V22.042l-.169.169a.9.9,0,0,0-.114.171c-.019.029-.049.046-.065.076L27.585,31.5H5.807v1.9h20.95a.94.94,0,0,0,.267.673.952.952,0,0,0,1.1.179l4.333-2.167Zm11.421.952V52.443a4.759,4.759,0,0,1-9.518,0V38.167ZM29.827,31.279l3.391-6.788,1.7,1.7,1.7,1.7ZM38.221,26.8l-1.285-1.285L52.691,9.761l1.285,1.285ZM56.7,8.325,55.321,9.7,51.86,6.238l-.454-.454L52.78,4.409a1.737,1.737,0,0,1,2.453,0L56.7,5.874A1.736,1.736,0,0,1,56.7,8.325Z",
    transform: "translate(0 0)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextsummarize);
export default __webpack_public_path__ + "static/media/textsummarize.8a2bf5c3.svg";
export { ForwardRef as ReactComponent };